import gql from 'graphql-tag'

export const SINCRONIZAR_GRUPOS = gql`
  mutation SincronizarGruposMutation {
    sincronizarGrupos
  }
`
